<script setup lang="ts"></script>

<template>
  <p class="mb-3">
    <slot name="question"></slot>
  </p>
  <div class="answer-container pa-3 mb-3">
    <slot name="answer"></slot>
  </div>
</template>

<style scoped lang="scss">
.answer-container {
  background-color: var(--light-grey-2);
  border-radius: 8px;
}
</style>

<style lang="scss">
.report-item-container {
  &__label {
    font-weight: bold;
  }
}
</style>